import { useEffect, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { snakeCase } from 'lodash'
import { Divider, message, notification } from 'antd'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { isValid } from '../../../utils/validators'
import { isObject } from '../../../utils'
import { Quota, QuotaValidators } from '../../../utils/entities/quota'
import QuotaForm, { QuotaFormModes } from './QuotaForm'
import { getQuotaTreshold } from '../../../utils/api/quota'
import FormFooter from '../../../Components/antd/Forms/FormFooter'

import '../../../assets/quotas.scss'

message.config({
  top: 20,
  duration: 3,
  maxCount: 1,
  placement: 'topRight'
})

const QuotaDesiderataForm = ({ data, disabled, sectors = [], sectionGroups = {}, studentPathways = [], validators = QuotaValidators, onDelete, onSubmit, onCancel }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [formData, setFormData] = useState(new Quota(isObject(data) ? data : { total: 0 }))
  const [availablePlaces, setAvailablePlaces] = useState(0)

  useEffect(() => {
    getQuotaTreshold(user, formData, { startDate: formData.startDate, endDate: formData.endDate }).then(({ data }) => setAvailablePlaces(data))
  }, [formData.id, formData.startDate, formData.endDate, user.id])

  const handleSubmit = event => {
    const errors = isValid(formData, Object.values(validators))

    if (errors.keys.length > 0) {
      const errorMessages = t('common_form.error_fields', {
        fields: errors.keys.map(key => t('common.' + snakeCase(key))).join(', ')
      })

      notification.error({ message: errorMessages })
    } else if (formData.startDate > formData.endDate) {
      message.error({ message: t('common_form.error_dates') })
    } else {
      onSubmit(new Quota({ ...formData, isDesiderata: false }))
    }
  }

  const isSubmitDisabled = useMemo(() => (
    formData.school === null || formData.total === null || formData.startDate === null || formData.endDate === null || disabled
  ), [formData.school, formData.total, formData.startDate, formData.endDate, disabled])

  return (
    <div>
      <div className='flex-column w-100 pd-12'>
        <QuotaForm
          data={formData}
          disabled={disabled}
          maxTotal={availablePlaces}
          mode={QuotaFormModes.RESTRICTED}
          sectors={sectors}
          sectionGroups={sectionGroups}
          studentPathways={studentPathways}
          onChange={setFormData}
        />
      </div>

      <Divider className='divider-4' />

      <FormFooter
        cancel={{ text: t('modal.cancel_button'), disabled }}
        remove={formData.id > 0 && {
          popover: { content: t('quota_desiderata_form.button.refuse'), title: t('common.delete') },
          text: t('common.refuse'),
          tooltip: t('common.delete')
        }}
        submit={{
          disabled: isSubmitDisabled,
          text: t('common.accept'),
          tooltip: isSubmitDisabled && t('quota_desiderata_form.button.accept', {
            fields: [
              t('common.period'),
              t('quota_form.places_to_allocate'),
              t('common.school')
            ].join(', ')
          })
        }}
        onCancel={onCancel}
        onDelete={onDelete}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default QuotaDesiderataForm
